app.service('productSetService', [
  'mainConfig',
  'slFeatureService',
  '$filter',
  'moneyService',
  function (mainConfig, slFeatureService, $filter, moneyService) {
    function calculateProductSetStock(productSetData) {
      var stocks = productSetData
        .filter(function (productData) {
          return (
            !productData.childProduct.unlimited_quantity &&
            !productData.childProduct.out_of_stock_orderable
          );
        })
        .map(function (productData) {
          return productData.childVariation
            ? productData.childVariation.quantity
            : productData.childProduct.quantity;
        });
      return Math.min.apply(null, stocks);
    }

    function generateProductSetParams(productSetData) {
      return productSetData.map(function (childProductData) {
        return {
          child_product_id: childProductData.childProduct._id,
          child_variation_id:
            childProductData.childVariation &&
            childProductData.childVariation.key,
        };
      });
    }

    function checkChildProductStock(product) {
      if (product.unlimited_quantity) return true;
      if (product.out_of_stock_orderable) return true;
      const hasVariation = product.field_titles?.length > 0;
      if (hasVariation) {
        const sumQuantity = product.variations.reduce((accu, curr) => {
          return accu + curr.quantity;
        }, 0);
        return sumQuantity >= (product.bundle_set?.min_quantity || 1);
      }

      return product.quantity >= (product.bundle_set?.min_quantity || 1);
    }

    function getCheckoutPrice({ product, basketCartItems }) {
      if (product.bundle_set.price_type === 'fixed_amount') {
        return product.price_sale;
      }

      let totalPrice = basketCartItems.reduce((acc, curr) => {
        const pricingTarget =
          !curr.same_price && curr.variationSelected
            ? curr.variationSelected
            : curr;
        return (
          acc +
          (pricingTarget.price_sale?.cents || pricingTarget.price?.cents || 0) *
            curr.quantity
        );
      }, 0);
      let discountAmount = 0;
      if (product.bundle_set.price_type === 'discount_percentage') {
        discountAmount = (totalPrice * product.bundle_set.discount_value) / 100;
        discountAmount = moneyService.bankersRound(discountAmount);
      } else if (product.bundle_set.price_type === 'discount_amount') {
        discountAmount = moneyService.dollarsToCents(
          product.bundle_set.discount_value,
          mainConfig.merchantData.base_currency.iso_code,
        );
      }
      totalPrice -= discountAmount;
      totalPrice = totalPrice > 0 ? totalPrice : 0;
      return moneyService.toMoney({
        cents: totalPrice,
      });
    }

    function getChildVariationName(variation) {
      return variation?.fields
        .map((field) => $filter('translateModel')(field.name_translations))
        .join(', ');
    }

    function getSelectedItemDetail(selectedChildProduct, item) {
      var childProduct = item.product.child_products.find((childProduct) => {
        return childProduct._id === selectedChildProduct.child_product_id;
      });
      var childVariation =
        selectedChildProduct.child_variation_id &&
        childProduct.child_variations?.find((childVariation) => {
          return childVariation.key === selectedChildProduct.child_variation_id;
        });

      return {
        childProductName: $filter('translateModel')(
          childProduct.title_translations,
        ),
        childVariationName:
          childVariation && getChildVariationName(childVariation),
      };
    }

    return {
      calculateProductSetStock: calculateProductSetStock,
      generateProductSetParams: generateProductSetParams,
      isProductSetEnabled: function (product) {
        return (
          product.type === 'product_set' &&
          slFeatureService.hasFeature('product_set')
        );
      },
      isProductSetRevampEnabled: function (product) {
        return (
          product.type === 'product_set' &&
          slFeatureService.hasFeature('product_set_revamp')
        );
      },
      checkMinQuantity: function (childProducts) {
        return childProducts.every(checkChildProductStock);
      },
      checkChildProductStock,
      getChildVariationName,
      getSelectedItemDetail,
      getCheckoutPrice,
    };
  },
]);
